import api from "./api.js";

export default class VuApi {
  // ---------- Vu:관리 ---------- //
  static async create(data) {
    return await api.post(`api/vu`, data);
  }

  static async getList(params) {
    return await api.get(`api/vu`, params);
  }

  static async delete(params) {
    return await api.del(`api/vu`, params);
  }

  static async getById(id) {
    return await api.get(`api/vu/${id}`);
  }

  static async update(id, data) {
    return await api.patch(`api/vu/${id}`, data);
  }

  static async updateActivation(id, data) {
    return await api.patch(`api/vu/activation/${id}`, data);
  }
}
